<template>
    <div :class="$attrs.class" class="terms-container">
        <div>
            <h4>{{ lang($t('popup_terms_info.title'))}}</h4>
            <ul style="list-style: none">
                <li v-for="(section, index) in lang($t('popup_terms_info.sections'))" :key="index">
                    <strong>{{ section.title }}</strong>
                    <p v-if="section.subtitle">{{ section.subtitle }}</p>
                    <div v-for="(item, i) in section.content" :key="i">
                        <p v-if="typeof item === 'string'">{{ item }}</p>
                        <ol v-else-if="item.list_type === 'ol'">
                            <li v-for="(li, j) in item.items" :key="j">{{ li }}</li>
                        </ol>
                        <ul v-else-if="item.list_type === 'ul'" class="number-list">
                            <li v-for="(li, j) in item.items" :key="j">{{ li }}</li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {common} from '@js/mixins/common'
export default {
    name: "PopupTermsContent",
    mixins: [common],
    inheritAttrs: false,
    methods: {
        currentWebsite() {
            let url = "http://" + window.location.host;
            if (window.location.protocol === "https:") {
                url = "https://" + window.location.host;
            }
            return `<a class="txt-link" href="${url}">${url}</a>`;
        }
    }
};
</script>

<style scoped>

* {
    line-height: revert;
    list-style: revert;
}

.terms-container {
    line-height: 1.6;
    font-size: 16px;
    color: #333;
}

.terms-container h3{
    margin-bottom: 20px !important;
}

.terms-container h4 {
    margin-top: 1.5em;
    margin-bottom: 0.5em;
}

.terms-container p {
    margin-bottom: 1em;
}

.terms-container ol,
.terms-container ul {
    margin: 0 0 1em 1.5em;
    list-style-type: decimal;
}

.terms-container li {
    margin-bottom: 0.5em;
}

.content-box > div {
    margin-bottom: 2em;
}

.number-list {
    list-style: decimal !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/PopupTermsContent.vue